import { Center, Spinner } from "@chakra-ui/react";
import {
  BuyerPublicBidDetailDto,
  useGetBuyerSeV2QuestionsQuery,
  useGetSourcingEventQuery,
} from "../../../../autogen/bff-api";
import { ClarificationsPanel } from "../communication/ClarificationsPanel";

export const ClarificationTab = ({ detail }: { detail: BuyerPublicBidDetailDto }) => {
  const eventId = detail.bid.forEvent;
  const { data: event, isLoading: eventLoading } = useGetSourcingEventQuery({ eventId });
  const { data: questionsData, isLoading: questionsLoading } = useGetBuyerSeV2QuestionsQuery({ eventId });

  if (eventLoading || questionsLoading || !event) {
    return (
      <Center py="10">
        <Spinner color="smPrimary" />
      </Center>
    );
  }

  return (
    <ClarificationsPanel
      event={event}
      questions={questionsData?.questions ?? []}
      supplierOrganizationId={detail.ownerOrganizationId}
    />
  );
};
